import React, { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { useTranslation, withTranslation } from 'react-i18next';

type Props = {
  idsToDelete: number[];
  itemsDeletedCallback?: () => void;
};

const HiddenMap = ({ idsToDelete, itemsDeletedCallback = () => {} }: Props) => {
  const { t } = useTranslation();
  const mapRef = useRef<any>(null);

  const getMapConfig = () => ({
    layer: window.REACT_APP_GIS_MAP_RISKS_LAYER,
    onItemsDeleted: itemsDeletedCallback,
    sso: 'Keycloak',
    mapName: 'CERES',
  });

  useEffect(() => {
    if (!mapRef.current && (window as any).CERNMap) {
      mapRef.current = new (window as any).CERNMap(
        document.getElementById('hiddenMap'),
        window.REACT_APP_GIS_MAP_URL,
        getMapConfig()
      );
    }
    return () => {
      if (mapRef.current) {
        mapRef.current.destroy();
        mapRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (idsToDelete.length > 0) {
      if (mapRef.current) {
        mapRef.current.deleteItems({ layer: 'Risks', ids: idsToDelete });
      } else {
        toast.error(t('message.title.error.batch.update.precise.locations.not.deleted'));
      }
    }
  }, [idsToDelete, t]);

  return <div id="hiddenMap" />;
};

export default withTranslation()(HiddenMap);
